// CC-050 — verdict word + score + one sentence by default; "Show full analysis" expands this block only.
import { useState } from "react";

export default function BriefAnalysis({ brief, testId, scoreTestId }) {
  const [open, setOpen] = useState(false);
  if (!brief || !brief.full) return null;
  return (
    <span className="block" data-testid={testId} data-expanded={open ? "true" : "false"}>
      <span className="flex flex-wrap items-baseline gap-x-2">
        {brief.label && <span className="text-[10px] uppercase tracking-wide text-[#6b7280]">{brief.label}</span>}
        <span className="font-semibold text-[#0e1420]" data-testid={`${testId}-verdict`}>{brief.verdict}</span>
        {brief.score && (
          <span className="font-mono text-[#0e1420]" data-testid={scoreTestId || `${testId}-score`}>{brief.score}</span>
        )}
      </span>
      <span className="block whitespace-pre-wrap text-[#0e1420]" data-testid={`${testId}-text`}>
        {open ? brief.full : brief.sentence}
      </span>
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
        className="mt-0.5 text-[11px] font-medium text-[#0072bc] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0072bc] rounded"
        data-testid={`${testId}-toggle`}
        aria-expanded={open}
      >
        {open ? "Hide full analysis" : "Show full analysis"}
      </button>
    </span>
  );
}
